import { httpClient } from './http-client';
import type {
  MissionControlApprovalItem,
  MissionControlApprovalsResponse,
  MissionControlCancelRunResponse,
  MissionControlProcessRunRef,
  MissionControlRunDetail,
  MissionControlRunListItem,
  MissionControlRunsResponse,
  ProcessRunRefKind,
} from '@vivport/backend/types/mission-control';

export type {
  MissionControlApprovalItem,
  MissionControlApprovalsResponse,
  MissionControlCancelRunResponse,
  MissionControlProcessRunRef,
  MissionControlRunDetail,
  MissionControlRunListItem,
  MissionControlRunsResponse,
  ProcessRunRefKind,
};

export async function listMissionControlRuns(limit = 20, cursor?: string): Promise<MissionControlRunsResponse> {
  const search = new URLSearchParams();
  search.set('limit', String(limit));
  if (cursor) {
    search.set('cursor', cursor);
  }
  return httpClient.get<MissionControlRunsResponse>(`/protected/mission-control/runs?${search.toString()}`);
}

export async function getMissionControlRun(runId: string): Promise<MissionControlRunDetail> {
  return httpClient.get<MissionControlRunDetail>(`/protected/mission-control/runs/${runId}`);
}

export async function listMissionControlApprovals(): Promise<MissionControlApprovalsResponse> {
  return httpClient.get<MissionControlApprovalsResponse>('/protected/mission-control/approvals');
}

export async function approveMissionControlApproval(approvalId: string): Promise<{ approvalId: string }> {
  return httpClient.post<{ approvalId: string }, { note?: string }>(`/protected/mission-control/approvals/${approvalId}/approve`, {});
}

export async function cancelMissionControlRun(
  runId: string | number,
  kind: ProcessRunRefKind
): Promise<MissionControlCancelRunResponse> {
  return httpClient.post<MissionControlCancelRunResponse, { kind: ProcessRunRefKind }>(
    `/protected/mission-control/runs/${runId}/cancel`,
    { kind }
  );
}

export async function rejectMissionControlApproval(approvalId: string, note?: string): Promise<{ approvalId: string }> {
  return httpClient.post<{ approvalId: string }, { note?: string }>(`/protected/mission-control/approvals/${approvalId}/reject`, note ? { note } : {});
}
